export default "__VITE_ASSET__303a2119__"